import { waLink } from "../lib/constants";

export const FloatingWA = ({ whatsapp, company }) => {
  if (!whatsapp) return null;
  const href = waLink(whatsapp, `Halo ${company || ""}, saya ingin menanyakan layanan service.`);
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Hubungi via WhatsApp"
      className="no-print group fixed bottom-5 right-5 z-[70] flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5a] text-white rounded-full shadow-xl shadow-emerald-900/30 pl-3.5 pr-4 py-3 transition-all hover:-translate-y-0.5"
      data-testid="floating-wa-btn"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping -z-10" />
      <i className="ph-bold ph-whatsapp-logo text-2xl" />
      <span className="hidden sm:inline text-sm font-extrabold">Chat WhatsApp</span>
    </a>
  );
};
